import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { hostNameBack } from '../../utils/constants';
import Loader from '../../utils/Loader';

function Requirements() {

    const { orderId } = useParams();
    const [order, setOrder] = React.useState(null);
    const token = localStorage.getItem("token");
    const [answers, setAnswers] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const navigate = useNavigate();

    React.useEffect(() => {
        axios.get(`${hostNameBack}/api/v1/orders/buyer/service/${orderId}?from=requirements`, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success)
                    setOrder(response.data.order);
            })
            .catch(e => {
                // enqueueSnackbar(e.response?.data?.error || "Something went wrong!", { variant: "error" });
            })
    }, [orderId, token])

    const questions = order && order.service.serviceId.questions.map((question, index) => {
        return <div className='inputDiv' key={index}>
            <label>{question} <span>*</span></label>
            <textarea
                type="text"
                className='inputField'
                placeholder='Enter Answer...'
                value={answers[index] || ''}
                onChange={(e) => handleChange(index, e.target.value)}
                required
            />
        </div>
    })

    const handleChange = (index, value) => {
        const newAnswers = [...answers];
        newAnswers[index] = value;
        setAnswers(newAnswers);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (answers.length !== order.service.serviceId.questions.length) {
            enqueueSnackbar("Please answer all Questions", { variant: "warning" })
            return;
        }

        const pairedAnswers = order.service.serviceId.questions.map((question, index) => ({
            question,
            answer: answers[index]
        }));

        try {
            setIsLoading(true);
            await axios.put(`${hostNameBack}/api/v1/orders/buyer/service/answers/${orderId}`, { answers: pairedAnswers }, { headers: { Authorization: `Bearer ${token}` } });
            enqueueSnackbar("Answers submitted successfully!", { variant: 'success' });
            navigate("/orders");
        } catch (e) {
            enqueueSnackbar(e?.response?.data?.error || "Failed to submit answers", { variant: 'error' });
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <div className='requirementsDiv'>

            {isLoading && <Loader type="checkmate" /> }

            <section className="section">
                <div className="requirementsContent">

                    <form className="form" onSubmit={handleFormSubmit}>
                        <h1 className="primaryHeading"><span>Req</span>uirements</h1>
                        <p>{order?.service?.serviceId?.sellerId?.fullName} has some questions for you to answer. Answer them and let's get started...</p>
                        {questions}
                        <button type='submit' className='primaryBtn'>Submit</button>
                    </form>

                </div>
            </section>
        </div>
    )
}

export default Requirements